// extracted by mini-css-extract-plugin
export default {"modalPanel":"ReportStoryView_modalPanel__-v+I8","storyIframe":"ReportStoryView_storyIframe__mqPrz"};